// extracted by mini-css-extract-plugin
export default {"tabview":"de58f5a2932252019f9d"};